import { render, staticRenderFns } from "./TerminalSalesList.vue?vue&type=template&id=22cc50c0"
import script from "./TerminalSalesList.vue?vue&type=script&lang=js"
export * from "./TerminalSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports